import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Accueil from './pages/Accueil';
import DetailsProduit from './pages/DetailsProduit';
import Panier from './pages/Panier';
import Paiement from './pages/Paiement';
import Connexion from './pages/Connexion';
import Inscription from './pages/Inscription';
import MesCommandes from './pages/MesCommandes';
import DashboardAdmin from './pages/DashboardAdmin';
import BarreNavigation from './composants/BarreNavigation';
import PiedPage from './composants/PiedPage';
import { useAuth } from './contexte/AuthContexte';

function RouteProtegee({ children }) {
  const { estConnecte } = useAuth();
  if (!estConnecte) return <Navigate to="/connexion" replace />;
  return children;
}

function RouteAdmin({ children }) {
  const { estAdmin } = useAuth();
  if (!estAdmin) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  const whatsappNumber = (process.env.REACT_APP_WHATSAPP_NUMBER || '').replace(/[^0-9]/g, '');
  const whatsappMessage = process.env.REACT_APP_WHATSAPP_MESSAGE || 'Bonjour, je souhaite avoir plus d\'informations.';
  const whatsappUrl = whatsappNumber
    ? `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`
    : '';

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <BarreNavigation />
      <main className="mx-auto w-full max-w-7xl px-4 py-6">
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/produits/:id" element={<DetailsProduit />} />
          <Route path="/panier" element={<Panier />} />
          <Route
            path="/paiement"
            element={
              <RouteProtegee>
                <Paiement />
              </RouteProtegee>
            }
          />
          <Route path="/connexion" element={<Connexion />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route
            path="/mes-commandes"
            element={
              <RouteProtegee>
                <MesCommandes />
              </RouteProtegee>
            }
          />
          <Route
            path="/admin"
            element={
              <RouteProtegee>
                <RouteAdmin>
                  <DashboardAdmin />
                </RouteAdmin>
              </RouteProtegee>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <PiedPage />

      {whatsappUrl ? (
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Contactez-nous sur WhatsApp"
          className="fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-emerald-600 text-white shadow-xl hover:bg-emerald-500 focus:outline-none focus:ring-4 focus:ring-emerald-200"
        >
          <svg viewBox="0 0 32 32" fill="currentColor" className="h-7 w-7" aria-hidden="true">
            <path d="M19.11 17.47c-.27-.14-1.59-.79-1.84-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.15-.42-2.19-1.34-.81-.72-1.36-1.61-1.52-1.88-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.47.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.47-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47-.16-.01-.34-.01-.52-.01-.18 0-.47.07-.72.34-.25.27-.95.93-.95 2.27 0 1.34.97 2.64 1.11 2.82.14.18 1.91 2.92 4.62 4.09.65.28 1.15.45 1.54.58.65.21 1.24.18 1.7.11.52-.08 1.59-.65 1.81-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.32z" />
            <path d="M16 3C9.38 3 4 8.38 4 15c0 2.12.56 4.19 1.62 6.01L4 29l8.2-1.56C13.97 28.46 14.98 28.7 16 28.7c6.62 0 12-5.38 12-12S22.62 3 16 3zm0 23.2c-.92 0-1.83-.17-2.69-.5l-.62-.24-4.86.92.95-4.73-.29-.66C7.39 19.5 6.8 17.27 6.8 15 6.8 9.92 10.92 5.8 16 5.8S25.2 9.92 25.2 15 21.08 26.2 16 26.2z" />
          </svg>
        </a>
      ) : null}
    </div>
  );
}
